



































































import { Component, Vue , Watch} from 'vue-property-decorator'
import TableForm from '@/components/common/TableForm.vue'
import SearchForm from '@/components/common/SearchForm.vue'
import JSwitch from '@/components/common/JSwitch.vue'
import $Api from '@api'
import { AccountPageRecord, AccountState ,RepaymentParams} from '@/api/model/account'
import { finalize } from 'rxjs/operators'
import { translate, DateTime } from '@/utils/filters'

@Component({
    components: {
        SearchForm,
        TableForm,
        JSwitch,
    }
})
export default class Repayment extends Vue {
    dateTime = DateTime
    total = 0
    formEl: any
    tableData: any = []
    tableLoading: boolean = false
    searchForm = {
        current: 1,
        size: 10,
        doubleLoan: '',
        startDate:null,
        endDate:null,
    }
    releaseTime = null
    defaultTime = ['00:00:00', '23:59:59']
    loading: boolean = false
    created(): void {
        this.getRepaymentData()
    }
    getRepaymentData(pageQuery={}):void {
        this.tableLoading = true
        Object.assign(this.searchForm, pageQuery)
        $Api.accountService.
            getRepaymentList(this.searchForm).
            pipe(
                finalize(() => {
                    this.tableLoading = false
                })
            )
            .subscribe(
            res=>{
                console.log('repay ==>',res)
                this.tableData = res.records
                this.total = res.total
            },
            err => {
                console.log(err.message)
            }
        )
    }
    onSearchSubmit(): void {
        this.searchForm.current = 1
        this.getRepaymentData()
    }

    @Watch('releaseTime')
    onReleaseTimeChange(date: [Date, Date]): void {
        if (!date) {
            this.searchForm.startDate = null
            this.searchForm.endDate = null
        } else {
            const [startDate, endDate] = date
            this.searchForm.startDate = startDate.getTime().toString()
            this.searchForm.endDate = endDate.getTime().toString()
        }
        // console.log(this.searchForm,'----repayment')
    }
    onFormReset(): void {
        this.releaseTime = null
    }
}
